import { IconButton, styled } from '@mui/material';

import type { CourseListViewMode } from 'Courses/pages/courses-list/CoursesListView.consts';
import { CoursesListViewConsts } from 'Courses/pages/courses-list/CoursesListView.consts';
import { Colors } from 'Themes/colors';

import { FormatListBulletedIcon, GridViewIcon } from '@libs/shared/ui/icons';

import { ActionsWrapper } from './CourseListViewActions.styles';

type Props = {
  viewMode: CourseListViewMode;
  onViewModeChange: (viewMode: CourseListViewMode) => void;
};

const StyledIconButton = styled(IconButton)<{ active: boolean }>`
  color: ${({ active }) => (active ? Colors.textColor : Colors.darkGrey)} !important;

  &:hover {
    color: ${Colors.blue} !important;
  }
`;

export const CourseListViewActions = ({ viewMode, onViewModeChange }: Readonly<Props>) => {
  const handleAdvancedViewClick = () => onViewModeChange(CoursesListViewConsts.viewMode.advanced);
  const handleSimpleViewClick = () => onViewModeChange(CoursesListViewConsts.viewMode.simple);

  return (
    <ActionsWrapper>
      <StyledIconButton
        onClick={handleAdvancedViewClick}
        active={viewMode === CoursesListViewConsts.viewMode.advanced}
        aria-label="Advanced view"
      >
        <GridViewIcon fontSize="large" />
      </StyledIconButton>
      <StyledIconButton
        onClick={handleSimpleViewClick}
        active={viewMode === CoursesListViewConsts.viewMode.simple}
        aria-label="Simple view"
      >
        <FormatListBulletedIcon fontSize="large" />
      </StyledIconButton>
    </ActionsWrapper>
  );
};
